module.exports = __webpack_public_path__ + "img/hot-beverage.041c2984.svg";